import { Box, Stack, useTheme } from "@mui/material";
import { Title } from "../general/typography";
import Loader from "../general/loader";
import { toLocaleString } from "../../scripts/utils";

function formatTimeToSeconds(timestamp) {
  if (!timestamp) return "";
  const date = new Date(timestamp);
  return date.toISOString().replace("T", " ").split(".")[0];
}

function Row({ startTime, endTime }) {
  return (
    <tr>
      <td>
        <b>{startTime}</b>
      </td>
      <td>
        <b style={{ paddingLeft: 60 }}>{endTime}</b>
      </td>
    </tr>
  );
}

function OutagesTable({ title, outages, sx }) {
  return (
    <Box sx={{ ...sx }}>
      <Stack direction="row" justifyContent="space-between" pb={2}>
        <Title>{title}</Title>
      </Stack>
      {outages.length === 0 ? (
        <Box sx={{ px: 1, py: 2, fontStyle: "italic", color: "gray" }}>No outages during this period</Box>
      ) : (
        <Box
          component="div"
          sx={{
            maxHeight: 150,
            overflowY: "auto",
            px: 1,
            display: "flex",
          }}
        >
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#fff",
                  zIndex: 1,
                }}
              >
                <th style={{ textAlign: "left", padding: "8px 0" }}>Start</th>
                <th style={{ textAlign: "left", padding: "8px 60px" }}>End</th>
              </tr>
            </thead>
            <tbody>
              {outages.map((outage, index) => (
                <Row
                  key={index}
                  startTime={toLocaleString(outage.START_UTC)}
                  endTime={toLocaleString(outage.END_UTC)}
                />
              ))}
            </tbody>
          </table>
        </Box>
      )}
    </Box>
  );
}
export default function PastOutages({ data, isFetching, ...props }) {
  const theme = useTheme();

  const siteOutagesData = data?.site_outages ? data.site_outages : [];
  const eliaOutagesData = data?.elia_outages ? data.elia_outages : [];

  return (
    <Box
      {...props}
      sx={{
        borderRadius: 3,
        border: `1px solid ${theme.palette.background.border}`,
        padding: 3,
        pb: 2,
        backgroundColor: "white",
        height: "100%",
        ...props.sx,
      }}
    >
      {isFetching ? (
        <Loader />
      ) : (
        <>
          <OutagesTable title="SITE OUTAGES" outages={siteOutagesData} />
          <OutagesTable title="ELIA OUTAGES" outages={eliaOutagesData} sx={{ mt: 4 }} />
        </>
      )}
    </Box>
  );
}
